import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

interface Queries {
  unitId?: number;
  positionId?: number;
  officeId?: number;
}

export const unitWiseEmployee = async (queries: Queries) => {
  const response = await api.get(`${apiEndPoint}/employee/unit-wise`, {
    params: queries,
  });
  return response.data;
};
